var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',[(!_vm.consent)?_c('consent-dialog',{attrs:{"person":_vm.person()}}):_vm._e(),_c('attendee-profile',_vm._g({attrs:{"person":_vm.person()}},_vm.$listeners))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }